const variables = {
  // TODO: breakpoints are not yet correctly configured for react-styled-flexboxgrid
  // theming is done in src/html.js but the library doesn't catch the config correctly
  // The queries below are now in sync with the react-styled-flexboxgrid library definitions.
  // They can be changed only after we get these ones syncing to the library
  media: {
    xs: 'screen and (min-width: 0px)',
    sm: 'screen and (min-width: 48em)',
    md: 'screen and (min-width: 64em)',
    lg: 'screen and (min-width: 75em)',
    xlg: 'screen and (min-width: 100em)'
  },

  fonts: {
    body: '\'Inter\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif',
    header: '\'Inter\', -apple-system, BlinkMacSystemFont, \'Segoe UI\', sans-serif',
    mono: '\'Source Code Pro\', \'SF Mono\', Monaco, Consolas, monospace',
  },

  headerScale: {
    h1Scale: 3.5,    // 56px / 16px base = 3.5rem
    h2Scale: 2.5,    // 40px / 16px base = 2.5rem
    h3Scale: 2,      // 32px / 16px base = 2rem
    h4Scale: 1.5,    // 24px / 16px base = 1.5rem
    h5Scale: 1.25,   // 20px / 16px base = 1.25rem
    h6Scale: 1.125,  // 18px / 16px base = 1.125rem
    // In small screens, scale header fonts with this ratio to make them better fit to viewport
    smallScreenHeaderScaleFactor: 0.57,  // 32px / 56px = 0.57 for mobile H1
    // Header margins are by default equal to their font-size. E.g. If h1 is 3.5rem,
    // it has 3.5rem margin-top and margin-bottom. This factor will will scale as wanted.
    // If the margin feels too large, we can scale it down to e.g. 0.7 which makes margin-bottom
    // 0.7 * 3.5rem = 2.45rem
    headerMarginTopFactor: 1.1,
    headerMarginBottomFactor: 0.7
  },

  maxContentWidth: 1400, // px
  navBarHeight: 90,

  // Main color name (medium) has been taken from: http://chir.ag/projects/name-that-color/
  colors: {
    // New theme colors - Knowledge Garden palette
    deepIndigo: '#37336B',     // Nav, footer, dark-mode bg
    coreViolet: '#5D50FF',     // Hero gradient start, H headings
    lightViolet: '#7E6DFF',    // Gradient end, subtle fills
    turquoiseAccent: '#12B5AD', // CTAs and interactive elements ONLY
    lightGrey: '#F4F5F8',      // Breathing-room sections
    charcoal: '#222326',       // Body copy
    
    // Main theme colors
    deepBlue: '#0c0f41',       // Primary brand color for headers and key elements
    mediumGrey: '#666666',     // Secondary text color
    backgroundGrey: '#f4f4f4', // Light background sections
    
    // Legacy colors kept for backwards compatibility
    jade: {
      darker: '#004121',
      dark: '#007e44',
      medium: '#00b06a',
      light: '#57d684',
      lighter: '#b0f1b5',
    },
    carnationPink: {
      darker: '#332721',
      dark: '#996467',
      medium: '#ffa9d3',
      light: '#ffcbd8',
      lighter: '#ffeff0',
    },
    silverTree: {
      darker: '#205341',
      dark: '#3f896e',
      medium: '#64b99a',
      light: '#88debf',
      lighter: '#baf5e0',
    },
    sunsetOrange: {
      darker: '#690a01',
      dark: '#b42515',
      medium: '#fd4f39',
      light: '#ffa273',
      lighter: '#ffe9cb',
    },
    bondiBlue: {
      darker: '#001526',
      dark: '#006a6d',
      medium: '#00a9b0',
      light: '#6ad7c6',
      lighter: '#d6f2f5',
    },
    pearlBrush: {
      darker: '#302e2c',
      dark: '#8d847f',
      medium: '#e7dbd3',
      light: '#f5f1e6',
      lighter: '#ffffff',
    },
    azureRadiance: {
      darker: '#013d7a',
      dark: '#015abe',
      medium: '#0077ff',
      light: '#65b2ff',
      lighter: '#c9e7ff',
    },
    eunry: {
      darker: '#563b3e',
      dark: '#926b71',
      medium: '#cb9ea5',
      light: '#e4b6bd',
      lighter: '#f5d5da',
    },
    oracle: {
      darker: '#00282f',
      dark: '#004548',
      medium: '#357972',
      light: '#a1c9b7',
      lighter: '#c5e4c7',
    },
    sunsetPurple: '#9B69FF',
  }
}

// Add convenience aliases which map to bootstrap color naming
variables.colors.primary = variables.colors.coreViolet
variables.colors.secondary = variables.colors.deepIndigo
variables.colors.accent = variables.colors.turquoiseAccent
variables.colors.success = variables.colors.jade.light
variables.colors.darkSuccess = variables.colors.jade.medium
variables.colors.danger = variables.colors.sunsetOrange.medium
variables.colors.warning = variables.colors.sunsetOrange.light
variables.colors.info = variables.colors.bondiBlue.medium
variables.colors.light = variables.colors.lightGrey
variables.colors.dark = variables.colors.deepIndigo
variables.colors.muted = variables.colors.pearlBrush.dark
variables.colors.white = '#fff'
variables.colors.transparent = 'transparent'

// Updated grey color definitions to match new theme
variables.colors.greyDarkest = variables.colors.charcoal
variables.colors.greyDark = '#5a6c7d'
variables.colors.grey = '#95a5a6'
variables.colors.greyLight = '#bdc3c7'
variables.colors.greyLightest = variables.colors.lightGrey

// Semantic color aliases for common use cases
variables.colors.brandPrimary = variables.colors.deepBlue
variables.colors.textPrimary = variables.colors.charcoal
variables.colors.textSecondary = variables.colors.mediumGrey
variables.colors.textMuted = variables.colors.greyDark
variables.colors.backgroundLight = variables.colors.lightGrey
variables.colors.backgroundMedium = variables.colors.backgroundGrey

export default variables
